import type { IngredientId } from '@libs/trip-planner-interfaces';

export enum ActivitySelectionPanelType {
  None = 'none',
  ActivityDetails = 'activityDetails',
}

export interface ActivitySelectionActivityDetailsPanel {
  type: ActivitySelectionPanelType.ActivityDetails;
  hotelCode: string;
  ingredientId: IngredientId;
}

export interface ActivitySelectionNoPanel {
  type: ActivitySelectionPanelType.None;
}

export type ActivitySelectionPanel =
  | ActivitySelectionActivityDetailsPanel
  | ActivitySelectionNoPanel;

export const ACTIVITY_SELECTION_NO_PANEL: ActivitySelectionNoPanel = {
  type: ActivitySelectionPanelType.None,
};
